import { useAppDispatch } from 'app/hooks'
import AsideMenu from 'components/AsideMenu'
import { openAside, closeAside } from './slice'
import { useCallback } from 'react'

interface AsideMenuItem {
  icon: string
  title: string
  to: string
}

interface AsideMenuProps {
  menu: AsideMenuItem[]
}

function AsideWrapper({ menu }: AsideMenuProps) {
  const dispatch = useAppDispatch()
  const openAsideAction = useCallback(() => {
    dispatch(openAside())
  }, [dispatch])

  const closeAsideAction = useCallback(() => {
    dispatch(closeAside())
  }, [dispatch])

  return (
    <AsideMenu
      menu={menu}
      openAside={openAsideAction}
      closeAside={closeAsideAction}
    />
  )
}

export default AsideWrapper
